import {
  buildMetricBreakdownUrl,
  buildOrdersDrilldownUrl,
  buildRevenueDrilldownUrl,
} from '@/lib/dashboard/buildDashboardDrilldownUrls'

/** IDs aligned with mover series in dashboardMovers.ts */
export type DashboardMoverSeriesId =
  | 'total_orders'
  | 'delivered_orders'
  | 'returned_orders'
  | 'total_revenue_all'
  | 'delivered_revenue'
  | 'total_expenses'
  | 'total_profit'

/**
 * Drill-down for a mover line: current dashboard range + shop + host (embedded app).
 * Returns null when shop/host missing.
 */
export function getDashboardMoverDrilldownHref(
  seriesId: DashboardMoverSeriesId,
  shop: string | null | undefined,
  host: string | null | undefined,
  dateFrom: string,
  dateTo: string
): string | null {
  const s = (shop ?? '').trim()
  const h = (host ?? '').trim()
  if (!s || !h) return null

  switch (seriesId) {
    case 'total_orders':
      return buildOrdersDrilldownUrl(s, h, dateFrom, dateTo, 'total')
    case 'delivered_orders':
      return buildOrdersDrilldownUrl(s, h, dateFrom, dateTo, 'delivered')
    case 'returned_orders':
      return buildOrdersDrilldownUrl(s, h, dateFrom, dateTo, 'returned')
    case 'total_revenue_all':
      return buildRevenueDrilldownUrl(s, h, dateFrom, dateTo, 'total_revenue_all')
    case 'delivered_revenue':
      return buildRevenueDrilldownUrl(s, h, dateFrom, dateTo, 'revenue_delivered')
    case 'total_expenses':
      return buildMetricBreakdownUrl(s, h, dateFrom, dateTo, 'total_expenses')
    case 'total_profit':
      return buildMetricBreakdownUrl(s, h, dateFrom, dateTo, 'total_profit')
    default: {
      const _exhaustive: never = seriesId
      return _exhaustive
    }
  }
}
